export var DEFAULT_COUNTRY_LIST = [
    { shortKey: "se", translationKey: "printorder:countries.Sweden" },
    { shortKey: "fi", translationKey: "printorder:countries.Finland" },
    { shortKey: "no", translationKey: "printorder:countries.Norway" },
    { shortKey: "dk", translationKey: "printorder:countries.Denmark" },
    { shortKey: "gb", translationKey: "printorder:countries.UnitedKingdom" },
    { shortKey: "nl", translationKey: "printorder:countries.Netherlands" },
    { shortKey: "at", translationKey: "printorder:countries.Austria" },
    { shortKey: "pl", translationKey: "printorder:countries.Poland" },
    { shortKey: "lt", translationKey: "printorder:countries.Lithuania" },
];
//# sourceMappingURL=countries.js.map